<div class="panel panel-primary">
  <div class="panel-heading">Picketline Walk Record edit form</div>
  <div class="panel-body">
    <form class="form-horizontal" role="form" data-testid="edit-walk-info-form" name="WalkInfoEdit">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 pull-left">
          <h1>
            {{
              walkHistoryRecord.FirstName +
                " " +
                walkHistoryRecord.MiddleName +
                " " +
                walkHistoryRecord.LastName
            }}
            - Edit form
          </h1>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-6">
          <div *ngIf="walkHistoryRecord.ImageExists">
            <img
              class="thumbnail img-responsive"
              width="250px"
              height="320px"
              src="Content/images/members/{{ walkHistoryRecord.MemberId }}.jpg"
              alt="{{ walkHistoryRecord.MemberId }}"
            />
            <br />
            <span class="control-label">{{ walkHistoryRecord.MemberId }}</span>
          </div>
          <div *ngIf="!walkHistoryRecord.ImageExists" data-testid="edit-walk-info-form-member-id">{{ walkHistoryRecord.MemberId }}</div>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-4">
          <label for="startDate" class="control-label">Date of the Walk:</label>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6">
          <p class="input-group">
            <input
              type="text"
              class="form-control"
              data-testid="edit-walk-info-form-walk-date"
              name="startDate"
              id="startDate"
              validate-on="blur"
              required-message="'Start Date is required'"
              bsDatepicker
              [bsConfig]="{ containerClass: 'theme-red',  dateInputFormat: 'YYYY-MM-DD'}"
              #dp="bsDatepicker"
              [(ngModel)]="walkHistoryRecord.WalkDate"
              ngRequired="true"
            />
            <span class="input-group-btn">
              <button
                type="button"
                class="btn btn-default"
                (click)="dp.show()"
                [attr.aria-expanded]="dp.isOpen"
              >
                <i class="glyphicon glyphicon-calendar"></i>
              </button>
            </span>
          </p>
          <!-- <p class="input-group">
            <input
              type="text"
              class="form-control"
              name="startDate"
              validate-on="blur"
              required-message="'Start Date is required'"
              bsDatePicker
              [bsConfig]="{ containerClass: 'theme-red' }"
              #dp="bsDatepicker"
              [(ngModel)]="walkHistoryRecord.WalkDate"
              ngRequired="true"
            />
            <span class="input-group-btn">
              <button
                type="button"
                class="btn btn-default"
                (click)="dp.show()"
                [attr.aria-expanded]="dp.isOpen"
              >
                <i class="glyphicon glyphicon-calendar"></i>
              </button>
            </span>
          </p> -->
        </div>
      </div>
      <div class="row">
        <div class="col-xs-6 col-sm-6 col-md-6" align="center">
          <label for="sign-in-time" class="timepicker-title label label-primary">Sign-in Time:</label>
          <timepicker
            [(ngModel)]="walkHistoryRecord.SignInTime"
            data-testid="edit-walk-info-form-in-time"
            name="sign-in-time"
            id="sign-in-time"
            [hourStep]="hourStep"
            [minuteStep]="minuteStep"
            show-meridian="true"
          >
          </timepicker>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-6" align="center">
          <label for="sign-out-time" class="timepicker-title label label-warning">Sign-out Time:</label>
          <timepicker
            [(ngModel)]="walkHistoryRecord.SignOutTime"
            data-testid="edit-walk-info-form-out-time"
            [hourStep]="hourStep"
            [minuteStep]="minuteStep"
            name="sign-out-time"
            id="sign-out-time"
            show-meridian="true"
          >
          </timepicker>
        </div>
      </div>
      <!--<hr />-->
      <div class="row">
        <div style="padding-left: 10px; padding-right: 10px">
          <label for="comments" class="control-label">Comments : </label>
          <textarea
            class="form-control"
            [(ngModel)]="walkHistoryRecord.Comments"
            data-testid="edit-walk-info-form-comments"
            name="comments"
            id="comments"
            rows="3"
            validate-on="blur"
            required
            required-message="'Comment is required'"
          ></textarea>
        </div>
      </div>
      <div class="row">
        <div style="padding-left: 10px; padding-right: 10px">
          <div class="col-xs-12 col-md-4">
            <input
              type="checkbox"
              data-testid="edit-walk-info-form-kicked"
              name="kickedOff"
              id="kickedOff"
              [(ngModel)]="walkHistoryRecord.KickedOff"
            />
            <label for="kickedOff" class="control-label">KickedOff</label>
          </div>
          <div class="col-xs-12 col-md-8">
            <label for="kickedOffReason" class="control-label">KickedOff Reason:</label>
            <textarea
              class="form-control"
              [(ngModel)]="walkHistoryRecord.KickedOffReason"
              data-testid="edit-walk-info-form-kicked-reason"
              name="kickedOffReason"
              id="kickedOffReason"
              rows="2"
            ></textarea>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="panel-footer clearfix">
    <div class="pull-right">
      <button type="button" class="btn btn-danger" (click)="cancelAction()">
        Cancel
      </button>
      <button
        type="button"
        data-testid="edit-walk-info-form-submit"
        class="btn btn-primary"
        (click)="updateRecord()"
        [disabled]="disableButton"
      >
        Save
      </button>
    </div>
  </div>
</div>
